import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TrustSignals = () => {
  const testimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    role: 'Tech Entrepreneur',
    company: 'CloudScale Solutions',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_141b6fda2-1763295319855.png",
    avatarAlt: 'Professional headshot of woman with shoulder-length brown hair wearing navy blazer and white blouse smiling confidently',
    rating: 5,
    quote: `AuthorPreneur AI transformed my expertise into a published book in just 6 weeks. The AI captured my voice perfectly, and I'm now getting speaking invitations I never had before. This platform is a game-changer for busy entrepreneurs.`,
    result: 'Published bestseller, 3 speaking engagements'
  },
  {
    id: 2,
    name: 'Marcus Johnson', role: 'Business Coach', company: 'Executive Growth Partners', avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1b2ab6858-1763300812722.png", avatarAlt: 'Professional headshot of African American man with short black hair wearing charcoal suit and burgundy tie with warm smile', rating: 5, quote: `I've been wanting to write a book for years but never had the time. The AI agents guided me through every step, and the quality exceeded my expectations. My credibility in the coaching space has skyrocketed since publishing.`,
    result: '2 books published, 40% client increase'
  },
  {
    id: 3,
    name: 'Jennifer Chen',
    role: 'Marketing Consultant',
    company: 'Digital Growth Agency',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_13677ef73-1763293657301.png",
    avatarAlt: 'Professional headshot of Asian woman with long black hair wearing teal blazer and pearl necklace with confident expression',
    rating: 5,
    quote: `The chapter-by-chapter writing mode let me maintain complete creative control while the AI handled the heavy lifting. My book on digital marketing strategies is now required reading in my industry. Worth every penny.`,
    result: 'Industry authority, 5x consultation rate'
  }];


  return (
    <section className="pt-20 lg:pt-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-primary/10 rounded-full mb-6">
            <Icon name="MessageSquare" size={16} color="var(--color-primary)" />
            <span className="text-sm font-medium text-primary">Success Stories</span>
          </div>

          <h2 className="text-3xl lg:text-5xl font-heading font-bold text-foreground mb-6">
            Entrepreneurs Building Authority
          </h2>

          <p className="text-lg text-muted-foreground">
            Join thousands of professionals who've transformed their expertise into published books and unlocked new opportunities.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials?.map((testimonial) =>
          <div
            key={testimonial?.id}
            className="bg-card border border-border rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">

              <div className="flex items-center space-x-3 mb-4">
                <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-primary/20">
                  <Image
                  src={testimonial?.avatar}
                  alt={testimonial?.avatarAlt}
                  className="w-full h-full object-cover" />

                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-semibold text-foreground truncate">
                    {testimonial?.name}
                  </h4>
                  <p className="text-xs text-muted-foreground truncate">
                    {testimonial?.role}
                  </p>
                </div>
              </div>

              <div className="flex items-center space-x-1 mb-4">
                {[...Array(testimonial?.rating)]?.map((_, index) =>
              <Icon key={index} name="Star" size={16} color="var(--color-accent)" />
              )}
              </div>

              <blockquote className="text-sm text-foreground leading-relaxed mb-4">
                "{testimonial?.quote}"
              </blockquote>

              <div className="pt-4 border-t border-border">
                <div className="flex items-center space-x-2">
                  <Icon name="TrendingUp" size={14} color="var(--color-success)" />
                  <span className="text-xs font-medium text-success">
                    {testimonial?.result}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-8 px-8 py-4 bg-muted rounded-full">
            <div className="flex items-center space-x-2">
              <Icon name="Award" size={20} color="var(--color-accent)" />
              <span className="text-sm font-medium text-foreground">4.9/5 Rating</span>
            </div>
            <div className="w-px h-6 bg-border" />
            <div className="flex items-center space-x-2">
              <Icon name="Users" size={20} color="var(--color-primary)" />
              <span className="text-sm font-medium text-foreground">2,500+ Authors</span>
            </div>
            <div className="w-px h-6 bg-border" />
            <div className="flex items-center space-x-2">
              <Icon name="BookOpen" size={20} color="var(--color-secondary)" />
              <span className="text-sm font-medium text-foreground">15,000+ Books</span>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default TrustSignals;